import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class ProfissionalServico extends Servico {
  constructor() {
    super('profissional')
  }

  recuperarAgendamentos(data) {
    const profissionalId = data.profissionalId
    return axios
      .get(`${URL}/${this.path}/${profissionalId}/agendamentos`, {
        params: data,
      })
      .then((result) => {
        return result.data
      })
      .catch((err) => {
        return this.verificarErro(err)
      })
  }

  recuperarAgendamentosTotal(data) {
    const profissionalId = data.profissionalId
    return axios
      .get(`${URL}/${this.path}/${profissionalId}/agendamentos/total`, {
        params: data,
      })
      .then((result) => {
        return result.data
      })
      .catch((err) => {
        return this.verificarErro(err)
      })
  }

  recuperarProfissionaisPorAgendamento(data) {
    return axios
      .get(`${URL}/${this.path}/searchByAgendamento`, { params: data })
      .then((result) => {
        return result.data
      })
      .catch((err) => {
        return this.verificarErro(err)
      })
  }

  recuperarHorariosAgendamento(data) {
    return axios
      .get(`${URL}/${this.path}/horarios`, { params: data })
      .then((result) => {
        return result.data
      })
      .catch((err) => {
        return this.verificarErro(err)
      })
  }

  adicionarDocumentoNoProfissional(idProfissional, idDocumento) {
    store.setCarregando()
    return axios
      .post(`${URL}/${this.path}/${idProfissional}/documentos`, {
        idDocumento: idDocumento,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  retornarDocumentos(idProfissional) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${idProfissional}/documentos`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  recuperarGuiasPagamento() {
    store.setCarregando()
    return axios
      .get(`${URL}/v2/profissionais/guias`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  criarGuiasPagamento(data) {
    store.setCarregando()
    return axios
      .post(`${URL}/v2/profissionais/guias`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  atualizarGuiasPagamento(id, data) {
    store.setCarregando()
    return axios
      .put(`${URL}/v2/profissionais/guias/${id}`, data)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }

  finalizarGuiasPagamento(id) {
    store.setCarregando()
    return axios
      .put(`${URL}/v2/profissionais/guias/${id}/finalizar`)
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default ProfissionalServico
